import React, { useEffect, useState } from "react";
import {
  TextField,
  Button,
  FormControl,
  Container,
  Grid,
  Box,
  Stack,
  OutlinedInput,
  InputLabel,
  MenuItem,
  ListItemText,
  Select,
  Checkbox,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormLabel,
  Modal,
  Typography,
} from "@mui/material";
// import "./test.css";
import SearchIcon from "@mui/icons-material/Search";

import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
// import { bookApoinment } from "./asppoinmentApi";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { routePath } from "../../constants/routePath";
import { setSession } from "../../utils/commonUtils";
import { setCustomerAppointmentId } from "../../app/store/reducer";
// import dayjs from 'dayjs';
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { getAlldetailSerice } from "../services/servicesListApi";
import EmployeeModal from "../../common/employeeModel";
import { addOffer, bulkMessage, bulkMessageApload } from "./apiFunction";
import ImageUploadButton from "../../common/imgUpload";
import SearchModalCustomer from "../../common/searchModal/customer";
import { ModalHeader } from "../../common/modalHeader";
import { useRef } from "react";
import { Filter } from "../../common/fiterComp";
dayjs.extend(utc);
dayjs.extend(timezone);

const PopUpWp = ({ open, setOpen, data }) => {
  const fileInputRef = useRef(null);

  // State to store the uploaded image URL
  const [imageSrc, setImageSrc] = useState(null);

  const [openT, setOpenT] = useState(false);
  const [selectedData, setSeletecData] = useState(null);
  const struct = {
    billerId: "",
    customerName: "",
    mobileNumber: "",
    // otp: "",
    mailId: "",
    gender: "",
    service: "",
    date: "",
    hour: "",
    minute: "",
    status: "Unassigned",
    employeeId: "",
  };
  const [selectedValue, setSelectedValue] = useState([]);
  useEffect(() => {
    let dd = "";
    console.log("selectedValueselectedValue ", selectedValue);
    selectedValue.forEach((ele, index) => {
      dd += ele.name + ",";
    });
    setSeletecData({ name: dd });
  }, [selectedValue]);
  const [formData, setFormData] = useState({ ...struct });
  // const handle = (e) => {
  //   e.preventDefault();
  //   // addOffer({message:formData.customerName},(data)=>{
  //   //     alert('ioni')
  //   // })
  //   // if(formData?.customerName || formData.customerName)
  //   const whatsappLink = `https://web.whatsapp.com/send?phone=${selectedData?.customerMobile}&text=${formData?.customerName}`;
  //   window.open(whatsappLink, "_blank");

  //   // setSeletecData("");
  // };
  
const handle = (e) => {
  e.preventDefault();
  if (!selectedData?.customerMobile) {
    alert("Please select a customer first!");
    return;
  }

  let message = formData.customerName || "";
  // let message = formData.imageUrl
  //   ? formData.imageUrl + "\n\n" + formData.customerName
  //   : formData.customerName;

  if (formData.imageUrl) {
    message += `\n\nImage: ${formData.imageUrl}`;
  }

  const encodedMessage = encodeURIComponent(message);
  const whatsappLink = `https://web.whatsapp.com/send?phone=${selectedData.customerMobile}&text=${encodedMessage}`;
  window.open(whatsappLink, "_blank");
};


  useEffect(() => {
    if (open == true) {
      console.log("Data", data);

      if (data) {
        setFormData({ ...formData, customerName: data?.message });
      }
    } else {
      setFormData(struct);
      setImageSrc(null);
    }
  }, [open]);
  const [search, setSearch] = useState("");
  return (
    <Modal
      open={open}
      onClose={() => {
        setOpen(false);
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          background: "white",
          width: { xs: "95%", sm: "60%", md: "50%", lg: "40%", xl: "30%" },
          // height: { sm: "60vh", md: "65vh", lg: "80vh", xs: "auto" },
          borderRadius: "10px",
          position: "absolute",
          left: { xs: "2%", sm: "25%", md: "25%", lg: "30%", xl: "35%" },

          top: "10%",
        }}
      >
        <ModalHeader
          title={"Message"}
          onClose={(data) => {
            {
              setOpen(data);
              setSeletecData("");
            }
          }}
        />
        <Container
          sx={{
            padding: "10px 8px !important",
          }}
        >
          <Box sx={{ overflowY: "auto", height: "60vh", paddingX: "10px" }}>
            <form onSubmit={handle}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12}>
                  <Box
                    // disabled
                    // size="small"
                    readonly
                    fullWidth
                    onClick={() => {
                      // setSearchOutStandingsModal(true)
                    }}
                    // id="name"
                    // label="Search by Name/Mobile Number"
                    // value={search}
                    sx={{
                      display: "flex",
                      height: "23px",
                      justifyContent: "space-between",
                      // width: "70%",
                      border: "1px solid #c9c9c9",
                      p: 1,
                      borderRadius: "4px ",
                      color: "grey",
                      "&:hover": {
                        cursor: "pointer !important",
                      },
                    }}
                    onChange={(e) => {
                      // setSearch(e.target.value);
                    }}
                  >
                    <Typography variant="p">
                      {/* {selectedData?.name !== "" ? search : "Search by Name/Mobile Number"} */}

                      {selectedData?.name !== ""
                        ? selectedData?.name
                        : "Search :"}
                    </Typography>
                    <SearchIcon
                      onClick={() => {
                        // setSearchModal(true)
                        setOpenT(true);
                      }}
                      sx={{
                        color: (theme) => theme.palette.primary.main,
                        cursor: "pointer",
                      }}
                    />
                  </Box>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <FormControl fullWidth margin="normal">
                    <TextField
                      label="Enter Message"
                      name="customerName"
                      value={formData.customerName}
                      onChange={(e) => {
                        setFormData({
                          ...formData,
                          customerName: e.target.value,
                        });
                      }}
                      required
                      multiline // Makes the TextField act as a textarea
                      rows={8} // Number of rows (you can adjust this)
                      InputLabelProps={{
                        className: "mulish",
                        sx: {
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        },
                      }}
                      InputProps={{
                        classes: { input: "mulish" },
                        sx: {
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        },
                      }}
                    />
                  </FormControl>
                </Grid>
                <Grid
                  item
                  xs={12}
                  // sx={{
                  //   borderBottom: "1px solid black",
                  //   paddingBottom: "10px",
                  // }}
                >
                  <ImageUploadButton
                    imageSrc={imageSrc}
                    setImageSrc={setImageSrc}
                    fileInputRef={fileInputRef}
                    fileCb={(url) => {
                      console.log("Image uploaded to Firebase, URL:", url);
                      setFormData({ ...formData, imageUrl: url }); // save URL to form data
                    }}
                  />
                </Grid>

                <Grid
                  item
                  xs={12}
                  sx={{
                    paddingX: "40px !important",
                    borderTop: "1px solid black",
                    mt: { xs: 13, md: 7, sm: 11, lg: 3 },
                    paddingBottom: "10px",
                  }}
                >
                  <Button
                    type="submit"
                    variant="contained"
                    fullWidth
                    sx={{
                      backgroundColor: "#01008B",

                      fontSize: { xs: "12px", sm: "13px", md: "18px" },
                    }}
                  >
                    Send Message
                  </Button>
                </Grid>
              </Grid>
            </form>
          </Box>
        </Container>{" "}
        <SearchModalCustomer
          searchModal={openT}
          selectedValue={selectedValue}
          setSelectedValue={setSelectedValue}
          setSearchModal={setOpenT}
          callback={(data) => {
            console.log("Data", data);
            setSeletecData(data);
            setOpenT(false);
          }}
        />
      </Box>
    </Modal>
  );
};

export default PopUpWp;
